module.exports = __webpack_public_path__ + "static/vmware_5.c30acf21.jpg";